import FacebookIcon from '@material-ui/icons/Facebook';
import GithubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import Particle from '../../Components/Particles';
import React from 'react';
import avatar from '../../img/avatar.png';
import styled from 'styled-components';

const HomePage = () => {
    // const FaceBookIcon = <i className="fab fa-facebook "></i>;
    // const GithubIcon = <i className="fab fa-github "></i>;
    // const InstagramIcon = <i className="fab fa-instagram "></i>;

    return (
        <HomePageStyled>
         <div className="particles-con">
             <Particle />
         </div> 
         
         <div className="typography">
         <div className="profile-img">
             <img src={avatar} className='img-fluid' alt="" />
         </div>
             <h1>Hi, I'm <span>Fahim Hasan</span></h1>
             <p>I'm a Front-End Developer. I work with React JS, Node Js, Express JS, MongoDb, React Bootstrap, Material UI and so on. You can find some of my work on my "Projects" Page. Please do give a visit to m works and let me know if you find it Good!!</p>
             <div className="icons">
                 <a target='_blank' rel="noreferrer" href='https://www.facebook.com/fahim.hasan801/' className="icon i-facebook">
                    <FacebookIcon />
                 </a>
                 <a target='_blank' rel="noreferrer" href='https://github.com/fahim-tonmoy' className="icon i-github">
                 <GithubIcon />
                 </a>
                 <a target='_blank' rel="noreferrer" href='https://www.instagram.com/tonmoy_fahim/' className="icon i-instagram">
                 <InstagramIcon />
                 </a>
             </div>
         </div>
        </HomePageStyled>
    );
};

const HomePageStyled = styled.header`
    width: calc(100%-50px);
    height: 100vh;
    position: relative;
    .typography {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 80%;
        .profile-img{
            /* width: 100%; */
            /* height: 400px; */
        }
        p {
            text-align: justify;
        }
        .icons {
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon {
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                text-decoration: none;
                &:hover {
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                }
                &:not(:last-child) {
                    margin-right: 1rem;
                }
                svg {
                    margin: .5rem;
                }
            }
            .i-instagram {
                &:hover {
                    /* background-color: var(--primary-color);
                     */
                    border: 2px solid #8a3ab9;
                    color: #8a3ab9;
                }
            }
            .i-github {
                &:hover {
                    /* background-color: var(--primary-color);
                     */
                    border: 2px solid #5f4687;
                    color: #5f4687;
                }
        }
    }
}


@media only screen and (max-width: 600px){
    margin-top: 40px;
    margin-bottom: 40px;
	.typography {
        h1{
            font-size: 30px;
            span {
                font-size: 40px;
            }
        }
        p{
            font-size: 20px;
            text-align: justify;
        }
        .icons{
            margin-bottom: 40px;
        }
    }
}

`;

export default HomePage;